import { useContext } from 'react';
// eslint-disable-next-line import/no-extraneous-dependencies
import { gql, useQuery } from '@apollo/client';
import { AppContext } from '@edx/frontend-platform/react';

const GET_ENROLLED_PATHWAYS = gql`
  query GetEnrolledPathways($userId: Int4!) {
    learningPathwayEnrollments(where: { userId: { _eq: $userId } }) {
      id
      learningPathway {
        id
        name
        image
      }
    }
  }
`;

export const useEnrolledPathways = (enabled = true) => {
  const { authenticatedUser } = useContext(AppContext);
  const userId = authenticatedUser?.id ?? authenticatedUser?.userId;

  const { data, loading, error } = useQuery(GET_ENROLLED_PATHWAYS, {
    variables: { userId },
    skip: !userId || !enabled,
    fetchPolicy: 'cache-and-network',
  });

  const enrolledPathways = (data?.learningPathwayEnrollments || [])
    .map((row) => row.learningPathway)
    .filter(Boolean);

  return { enrolledPathways, loading, error };
};
